import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_@babel+core@7.27.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/navbar/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/page-layout/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/page-components/blogs/server-components/ClientProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/page-components/blogs/server-components/RecommendedBlogs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/page-components/blogs/server-components/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/page-components/blogs/server-components/server-content.module.css");
